import React, { useState } from 'react';
import { DropdownMenu, SparkIcon, TagColored } from '@spark';

export const ROLE_OPTIONS = ['Admin', 'Editor', 'Viewer', 'Unassigned'];
export const INVITE_ROLE_OPTIONS = ['Admin', 'Editor', 'Viewer'];

export const ROLE_TAG_VARIANT = {
    Editor: 'pink',
    Admin: 'purple',
    Viewer: 'cyan',
    Unassigned: 'yellow',
};

export default function UserRoleSelect({ role, onChange, roles }) {
    const [open, setOpen] = useState(false);
    const options = roles?.length ? roles : ROLE_OPTIONS;

    return (
        <DropdownMenu
            className="settings-users__role-select"
            showLabel={false}
            placeholder=""
            text=""
            value={role}
            open={open}
            onOpenChange={setOpen}
            prefixIcon={(
                <TagColored
                    className="settings-users__role-tag"
                    variant={ROLE_TAG_VARIANT[role] || 'yellow'}
                    label={(
                        <>
                            {role}
                            <SparkIcon slug="chevron-down" size="small" />
                        </>
                    )}
                />
            )}
            panelClassName="settings-users__role-dropdown-panel"
            items={options.map((label) => ({ label, disableWhenReadOnly: true }))}
            onSelect={(item) => {
                onChange?.(item.label);
                setOpen(false);
            }}
        />
    );
}
